var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"c-loading-page",attrs:{"id":"loading-overlay"}},[_c('div',{staticClass:"c-loading-page__overlay"}),_c('div',{staticClass:"c-loading"},[_c('div',{staticClass:"one"}),_c('div',{staticClass:"two"}),_c('div',{staticClass:"three"}),_c('div',{staticClass:"four"})])])
}]

export { render, staticRenderFns }